module.exports = __webpack_public_path__ + "static/media/navbarlogo.9da2c2ad.png";